<template>
  <div class="show-mypage-checkin-area">
    <p class="list-title">
      <img src="@/assets/pin-green.svg" />チェックイン済みのスポット
    </p>
    <div class="noData" v-if="checkinList.length === 0">
      <p>チェックイン済みのスポットはありません</p>
    </div>
    <ul v-else class="list">
      <li
        v-for="(checkinItem, index) in checkinList"
        :key="checkinItem.CreatedAt"
        @click="onClickMission(checkinItem.spotId)"
        class="list-item"
        v-show="index < 3 || isExpand"
      >
        <div>
          <p>{{ checkinItem.spotName }}</p>
          <p class="mission-date">
            {{ formatDate(checkinItem.CreatedAt) }}
          </p>
        </div>
        <img class="chev" src="@/assets/chevron.svg" />
      </li>
      <li
        class="expandIcon"
        @click="onClickExpand"
        v-if="checkinList.length > 3"
      >
        <img :class="{ isExpand: isExpand }" src="@/assets/chevron.svg" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "checkin-list",
  computed: {
    ...mapState(["checkinList"]),
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    formatDate(date) {
      const dt = new Date(date);
      return `${dt.getFullYear()}年${dt.getMonth() + 1}月${dt.getDate()}日`;
    },
    onClickMission(spotId) {
      this.$emit("click-mission", spotId);
    },
    onClickExpand() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.show-mypage-checkin-area {
  margin: 0 1.25rem;
}

.noData {
  color: #aaa;
  font-size: 0.8rem;
}
.list-title {
  display: flex;
  align-items: center;
  margin: 2rem 0 0;
  img {
    margin-right: 0.5rem;
    width: 1.2rem;
  }
}
.list {
  list-style: none;
  margin: 0.5rem 0;
  padding: 0;
  .list-item {
    margin: 0;
    display: flex;
    padding: 1rem 0.5rem;
    border-top: 1px #e7e7e7 solid;
    position: relative;
    font-size: 0.9rem;
    align-items: center;

    .chev {
      transform: rotate(-90deg);
      height: 0.5rem;
    }

    > div {
      width: 100%;
    }

    p {
      margin: 0;
      width: calc(100% - 1.5rem);
    }

    .mission-date {
      color: grey;
      font-size: 0.8rem;
      margin-top: 0.25rem;
    }
  }
  .expandIcon {
    border-top: 1px #e7e7e7 solid;
    padding-top: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 1rem;
    }
    .isExpand {
      transform: rotate(180deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/CheckInList.vue